import CustomSection from '@src/quince-site-common/src/domains/CustomSection'

export const isTextBlockWithIconRowSectionDataValid = (section: CustomSection | undefined) => {
  if (!section) {
    return
  }

  const areSubSectionsValidLength = (section?.subSections || []).length === 3
  const areValidIconsPresent = (section?.subSections || []).filter(ss => ss.images?.length === 0).length === 0

  return areSubSectionsValidLength && areValidIconsPresent
}
